// removed by extract-text-webpack-plugin
module.exports = {"header":"_3JYQX _37W4X _2AJrG","sectionHeader":"_2t5sZ _1FLRv PYP7R _38618 _3Dqep","list":"_1c_Rr _38618 _3Dqep _1aL0S","sectionList":"_3JRr7 _1c_Rr _38618 _3Dqep _1aL0S _2Hk-A _2XN97","option":"_14UYr _1FLRv _38618 _3-Ogs _1a-AI","dropdownButton":"_3OfvB _38618 Wr_al _31ino _3-Ogs","chevron":"_6GHBB BcFLh","category":"_3q1QM _1FLRv _1a-AI _2rmlO"};


//////////////////
// WEBPACK FOOTER
// ./questions/components/LabelIconPicker.css
// module id = 2035
// module chunks = 3